<template>
  <div class="positionfixed">
    <Header></Header>
  <div class="pc_all FreeCreation">
    <div class="pc_all_content">
      <div
        class="FreeCreationNav animate__animated animate__fadeInDown"
        style="animation-delay: 0.2s"
      >
        <div class="FreeCreationNav_btn">
          <router-link to="/ailogo/FreeCreation/FreeCreation" class="FreeCreationNav_list font20">
            <span class="iconfont icon-chuangzuozhezhongxin"></span>自由创作
          </router-link>
          <router-link to="/ailogo/LetterLogo/LetterLogo" class="FreeCreationNav_list font20">
            <span class="iconfont icon-fa-buysellads"></span>字母LOGO
          </router-link>
          <router-link to="/ailogo/SameCreation/SameCreation" class="FreeCreationNav_list font20 active">
            <span class="iconfont icon-AItongkuan"></span>同款创作
          </router-link>
        </div>
      </div>
      <div
        class="LetterLogoTitle font20 animate__animated animate__fadeInDown"
        style="animation-delay: 0.4s"
      >
        参考图请尽量不要带文字
      </div>
      <div class="SameCreation">
        <div
          class="SameCreation_left animate__animated animate__fadeInDown"
          style="animation-delay: 0.6s"
        >
          <!-- This section will be hidden when an image is uploaded -->
          <div class="SameCreation_left_icon" v-if="!imageUrl" @click="triggerFileUpload">
            <div class="left_icon_dd">
              <img alt="" src="@a/ailogo/images/bn6.png" />
            </div>
            <div class="left_icon_dt font16">
              在此处拖放文件或选择文件<br />支持JPG/JPEG/PNG，20M以内
            </div>
          </div>

          <input
            type="file"
            ref="fileInput"
            accept="image/*"
            @change="handleFileUpload"
            style="display: none"
          />

          <!-- This section will be shown when an image is uploaded -->
          <div class="SameCreation_left_img" v-if="imageUrl">
            <div
              class="SameCreation_left_close iconfont icon-a-qingkong1"
              @click="clearImage"
            ></div>
            <img :src="imageUrl" alt="Uploaded Image" />
          </div>
        </div>
        <div
          class="SameCreation_right animate__animated animate__fadeInDown"
          style="animation-delay: 0.8s"
        >
          <div class="SameCreation_right_title">
            <div class="LetterLogoTitle font18">
              如没有参考图，可<span>前往LOGO精选页面</span>选图
            </div>
          </div>
          <div class="SameCreation_right_title">
            <div class="LetterLogoTitle font18">没有合适图片？试试</div>
            <router-link to="/ailogo/EnterBrand/EnterBrand" class="right_title_btn font18"
              >LOGO自由创作 ></router-link
            >
          </div>
        </div>
      </div>
      <div
        class="SameCreationBottom animate__animated animate__fadeInDown"
        style="animation-delay: 1s"
      >
        <div class="SameCreationBottomTop">
          <div class="SameCreationBottomTop_list font18">0</div>
          <div class="SameCreationBottomTop_list font18">0.5</div>
          <div class="SameCreationBottomTop_list font18">0.8</div>
        </div>
        <div class="slider-container">
          <input
            type="range"
            v-model="threshold"
            :min="minValue"
            :max="maxValue"
            :step="0.01"
            @input="updateThreshold"
          />
          <!-- <p>当前参考强度: {{ threshold }}</p> -->
        </div>
        <div
          class="SameCreationBottom_title font16 animate__animated animate__fadeInDown"
          style="animation-delay: 1.2s"
        >
          参考强度<span>（数量越大与参考图越相似）</span>
        </div>
      </div>
      <div class="Btn animate__animated animate__fadeInDown" style="animation-delay: 1.2s">
        <router-link
          to="/ailogo/EnterBrand/EnterBrand" class="Btn_prev font20" @click="goBack">
          <span class="iconfont icon-xiangyou"></span>上一步
        </router-link>
        <div :class="['Btn_next font20', { active: isNextActive }]" @click="goToFreeCreation">
          <div class="form_btn_po">继续<span class="iconfont icon-xiangyou"></span></div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Header from '@c/header/header'
export default {
  data() {
    return {
      threshold: 0.3, // 初始阈值
      minValue: 0, // 最小值
      maxValue: 0.8, // 最大值
      imageUrl: null, // Holds the uploaded image URL
      isNextActive: false // Indicates if the next button should be active
    }
  },
  components: {
    Header
  },
  methods: {
    updateThreshold() {
      console.log('当前阈值:', this.threshold) // 确认值是否变化
    },
    triggerFileUpload() {
      this.$refs.fileInput.click() // Trigger the hidden file input
    },
    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file && file.size < 20 * 1024 * 1024) {
        // Check file size limit (20MB)
        this.imageUrl = URL.createObjectURL(file) // Create a URL for the uploaded image
        this.isNextActive = true // Set the next button to active
      } else {
        alert('文件大小超过限制或格式不正确')
      }
    },
    clearImage() {
      this.imageUrl = null // Clear the uploaded image
      this.$refs.fileInput.value = '' // Reset the file input
      this.isNextActive = false // Set the next button to inactive
    },
    goToFreeCreation() {
      if (this.isNextActive) {
        this.$router.push('/ailogo/SameCreation/SameCreationKeyword')
      }
    },
    goBack() {
      this.$router.push({ name: 'EnterBrand' })
    }
  }
}
</script>

<style>
@import "SameCreation.css";
</style>
